import React from "react";
import "../../styles/uploadimage.css";
import "../../styles/static-content.css";


export default class EveryonePlatform extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (

            <div className="main-hts-section">

                <div className="main-bg-platform-everyone">
                    <h1 className="plat-main-heading">PLATFORM FOR EVERYONE</h1>
                    <div className="line-2"></div>
                </div>

                <div className="mt-65">

                    <div className="bg-grey">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <h1 className="plat-subheading mt-25">
                                        A platform for artists, art collectors and everyone who appreciates non digital
                                        art.
                                        YourMasterpieces allows you to buy and sell art, showcase art that you have created
                                        or
                                        just own.
                                    </h1>

                                    <div className="main-block-hts">

                                        <h2 className="section-title">A HAVEN FOR ART BUYERS</h2>
                                        <div className="line-2"></div>

                                        <div className="row card-section-hts">
                                            <div className="col-md-4">
                                                <div className="package-grid-item with-border">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/appreciate_icon.png')}/>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">APPRECIATE</h4>
                                                        <p className="card-desc-text">
                                                            Find artworks you like and share the regards with the artist
                                                            for his efforts
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item with-border">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/collect_icon.png')}/>
                                                    </div>


                                                    <div className="content-card">
                                                        <h4 className="card-heading">COLLECT</h4>
                                                        <p className="card-desc-text">
                                                            Collect artworks in a collection
                                                            so &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  you can
                                                            cherish them
                                                            later  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item with-border">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/buy_icon.png')}/>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">BUY</h4>
                                                        <p className="card-desc-text">
                                                            Buy artworks that you liked or have collected for your walls
                                                            so it can speak a story
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">

                                    <div className="main-block-hts">

                                        <h2 className="section-title">AN EMPOWERMENT PLATFORM FOR ARTISTS</h2>
                                        <div className="line-2"></div>

                                        <div className="row card-section-hts">
                                            <div className="col-md-4">
                                                <div className="package-grid-item">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/showcase_icon.png')}/>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">SHOWCASE</h4>
                                                        <p className="card-desc-text">
                                                            Publish artworks you want to sell or showcase on your very
                                                            personal web page
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/connect_icon.png')}/>
                                                    </div>


                                                    <div className="content-card">
                                                        <h4 className="card-heading">CONNECT</h4>
                                                        <p className="card-desc-text">
                                                            Connect with other artists, art appreciators and buyers,
                                                            grow your reach
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/emerge_icon.png')}/>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">EMERGE</h4>
                                                        <p className="card-desc-text">
                                                            Grow your reach, sell your art and emerge as the artist you
                                                            always wanted to be
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="bg-black">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">

                                    <div className="main-block-hts">

                                        <h2 className="section-title white-text">HOW TO BUY & SELL</h2>
                                        <div className="line-2"></div>

                                        <div className="row card-section-hts">
                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/buyrequest_icon.png')}/>
                                                    </div>

                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">1</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">BUY REQUEST</h4>
                                                        <p className="card-desc-text">
                                                            The buyer places a request on the artwork of choice
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/request_process_icon.png')}/>
                                                    </div>

                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">2</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">REQUEST PROCESSED</h4>
                                                        <p className="card-desc-text">
                                                            The seller approves or rejects the buy request received
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/Payment_icon.png')}/>
                                                    </div>

                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">3</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">BUYER PAYS</h4>
                                                        <p className="card-desc-text">
                                                            The buyer makes the payment of the artwork
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/ship_icon.png')}/>
                                                    </div>

                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">4</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">SELLER SHIPS</h4>
                                                        <p className="card-desc-text">
                                                            Seller packs and ships the artwork to the buyers address
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/credits_icon.png')}/>
                                                    </div>
                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">5</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">SELLER RECEIVES CREDITS</h4>
                                                        <p className="card-desc-text">
                                                            You receive a credit note for the amount of the artwork
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="package-grid-item mt-5">
                                                    <div className="image-card">
                                                        <img className="hts-card-image"
                                                             src={require('../../assets/cash_icon.png')}/>
                                                    </div>
                                                    <div className="number-grid grey-theme">
                                                        <h2 className="number-text">6</h2>
                                                    </div>

                                                    <div className="content-card">
                                                        <h4 className="card-heading">SELLER RECEIVES CASH</h4>
                                                        <p className="card-desc-text">
                                                            Credits are converted to cash when buyer receives artwork
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-grey">
                        <div className="main-block-hts mt-0 mb-0">

                            <div className="container">
                                <div className="col-md-12">

                                    <h2 className="section-title mt-25">QUESTIONS</h2>
                                    <div className="line-2"></div>

                                    <div className="row pt-25 mb-25">
                                        <div className="col-md-8">
                                            <div className="package-grid-item grid-2">
                                                <h4 className="card-heading-second">HOW TO JOIN</h4>
                                                <p className="card-desc-text-second">
                                                    We know how everyone dislikes long and complicated sign up
                                                    processes. We dislike them too! While designing the signup process
                                                    for YourMasterpieces your comfort and ease was our biggest priority
                                                    and we tried to keep it to as few steps as possible.


                                                </p>

                                                <h2 className="grey-text-bold link mb-15 mt-25">Click on Sign
                                                    Up</h2>

                                                <p className="card-desc-text-second mb-25 pb-35">

                                                    Fill in basic details like your full name, account name, city,
                                                    country of residence, email and set your password to complete your
                                                    profile, and you are done!

                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="package-grid-item grid-2">
                                                <h4 className="card-heading-second">SELLER TERMS OF USE</h4>
                                                <p className="card-desc-text-second">We are an open platform but
                                                    we
                                                    need
                                                    you keep in mind and follow the <a className="agree-link" href="/terms-and-conditions"  style={{color : "#BEA57C"}}>terms of use</a> here.
                                                </p>
                                            </div>
                                            <div className="package-grid-item grid-2">
                                                <h4 className="card-heading-second">GET HELP</h4>
                                                <p className="card-desc-text-second">
                                                    Having trouble or need some help? Get in touch with your
                                                    queries
                                                    at <a className="link"
                                                          href="mailto:support@yourmasterpieces.com">support@yourmasterpieces.com</a>
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/static/platform-for-everyone.js